module.exports = __webpack_public_path__ + "img/exclamation-triangle-solid.a35f82b9.svg";